<template>
    <div class="big-container">
      <header class="header">
        <img src="https://encaucetotal.com/wp-content/uploads/2021/03/planeta-encauce-300x300.png" alt="Encauce Logo" class="logo" />
        <h1 class="heading">Registro de Usuario</h1>
      </header>
      <div class="container">
        <div class="register-form">
          <h3>Complete el formulario de registro</h3>
          <form @submit.prevent="submitRegistration">
            <div class="form-group">
              <label for="first-name">Nombres</label>
              <input v-model="firstName" type="text" id="first-name" required>
            </div>
            <div class="form-group">
              <label for="last-name">Apellidos</label>
              <input v-model="lastName" type="text" id="last-name" required>
            </div>
            <div class="form-group">
              <label for="email">Correo electrónico</label>
              <input v-model="email" type="email" id="email" required>
            </div>
            <div class="form-group">
              <label for="phone">Número de teléfono</label>
              <input v-model="phone" type="tel" id="phone" required>
            </div>
            <div class="form-group">
              <label for="birth-date">Fecha de nacimiento</label>
              <input v-model="birthDate" type="date" id="birth-date" required>
            </div>
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input v-model="password" type="password" id="password" required>
              <small class="password-rules">Debe contener al menos 9 caracteres, incluyendo una mayúscula, una minúscula, un número y un carácter especial.</small>
            </div>
            <button type="submit">Registrar</button>
          </form>
        </div>
      </div>
    </div>
  </template>
 
 <script>
 import swal from 'sweetalert2';
 
 export default {
   name: 'RegisterAfterPayment',
   data() {
     return {
       firstName: '',
       lastName: '',
       email: '',
       phone: '',
       birthDate: '',
       password: ''
     };
   },
   methods: {
     async submitRegistration() {
       const signupForm = {
         firstName: this.firstName,
         lastName: this.lastName,
         email: this.email,
         phone: this.phone,
         birthDate: this.birthDate,
         password: this.password
       };
 
       try {
         await this.$store.dispatch('signupAfterPayment', signupForm);
         swal.fire('¡Registro Exitoso!', 'Tu registro ha sido exitoso. Ahora puedes iniciar sesión.', 'success');
         // Realizar login automáticamente
         await this.$store.dispatch('login', { email: signupForm.email, password: signupForm.password });
         // Redirigir después del login exitoso
         this.$router.push('/stem-1');
       } catch (error) {
         console.error('Error en el registro:', error);
         swal.fire('Error', 'Hubo un problema con el registro. Por favor, intenta de nuevo.', 'error');
       }
     }
   }
 };
 </script>
 
  
  <style scoped>
  .big-container {
    background: linear-gradient(45deg, #22113d, #2f355e);
    height: 100vh;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
    overflow-y: auto; /* Añadir scroll en el eje y */
  }
  
  .container {
    margin-top: 1em;
    max-width: 800px;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  
  .header {
    width: 800px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    margin-top: 1.6em;
  }
  
  .logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  
  .heading {
    font-size: 0.9em; /* 20px */
    color: #fff;
    margin: 0;
  }
  
  .register-form {
    width: 100%;
    padding: 20px;
  }
  
  .register-form h3 {
    font-size: 20px;
    color: #32325d;
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    font-size: 14px;
    color: #6b7c93;
    margin-bottom: 5px;
  }
  
  .form-group input {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    color: #495057;
    border: 1px solid #ced4da;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  .form-group input::placeholder {
    color: #999;
  }
  
  button[type="submit"] {
    width: 100%;
    padding: 15px;
    font-size: 16px;
    color: #fff;
    background-color: #6772e5;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  button[type="submit"]:hover {
    background-color: #5469d4;
  }
  
  .password-rules {
    font-size: 12px; /* Ajustar el tamaño de letra */
    color: #6b7c93;
    display: block;
    margin-top: 5px;
  }
  </style>
  